module.exports = __webpack_public_path__ + "static/media/Delete 2.b43fa067.svg";